import React from 'react';
import { TextField } from '@mui/material';
import { formatNumericField } from '../../../singleLineField/utils';
import { useComparisonFilter } from './useComparisonFilter';
var NumberFilter = function (_a) {
    var numberColumn = _a.numberColumn, onFilterChange = _a.onFilterChange;
    var _b = useComparisonFilter(numberColumn, onFilterChange), comparisonSelectorComponent = _b[0], filterValue = _b[1], onFilterValueChange = _b[2];
    var handleNumberChange = function (event) {
        var newNumberValue = formatNumericField(filterValue, event.target.value, numberColumn.numericFormat);
        onFilterValueChange(newNumberValue);
    };
    return (React.createElement("div", { className: "columnFilter columnFilter--withComparisonSelector" },
        !numberColumn.hideComparisonSelector && comparisonSelectorComponent,
        React.createElement(TextField, { name: numberColumn.name + "-filter", type: "text", value: filterValue !== null && filterValue !== void 0 ? filterValue : '', onChange: handleNumberChange, fullWidth: true, disabled: !numberColumn.filterable, className: "columnFilter numberFilter" })));
};
export default NumberFilter;
//# sourceMappingURL=NumberFilter.js.map